export const TOUR_AWAITED_ACTION_LIST_SUCCESS = "TOUR_AWAITED_ACTION_LIST_SUCCESS";
export const TOUR_AWAITED_ACTION_LIST_ERROR = "TOUR_AWAITED_ACTION_LIST_ERROR";
export const TOUR_AWAITED_ACTION_LIST_START = "TOUR_AWAITED_ACTION_LIST_START";